
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { registerLocaleData } from '@angular/common';
import arAE from '@angular/common/locales/ar-AE';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

registerLocaleData(arAE, 'ar-AE');

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

